import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { BaseEntity } from './base.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum BaseActionTypes {
  LoadBases = '[Base] Load Bases',
  AddBase = '[Base] Add Base',
  UpsertBase = '[Base] Upsert Base',
  AddBases = '[Base] Add Bases',
  UpsertBases = '[Base] Upsert Bases',
  UpdateBase = '[Base] Update Base',
  UpdateBases = '[Base] Update Bases',
  DeleteBase = '[Base] Delete Base',
  DeleteBases = '[Base] Delete Bases',
  ClearBases = '[Base] Clear Bases',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadBases implements Action {
  public readonly type = BaseActionTypes.LoadBases;

  constructor(public payload: { bases: BaseEntity[] }) {}
}

export class AddBase implements Action {
  public readonly type = BaseActionTypes.AddBase;

  constructor(public payload: { base: BaseEntity }) {}
}

export class UpsertBase implements Action {
  public readonly type = BaseActionTypes.UpsertBase;

  constructor(public payload: { base: BaseEntity }) {}
}

export class AddBases implements Action {
  public readonly type = BaseActionTypes.AddBases;

  constructor(public payload: { bases: BaseEntity[] }) {}
}

export class UpsertBases implements Action {
  public readonly type = BaseActionTypes.UpsertBases;

  constructor(public payload: { bases: BaseEntity[] }) {}
}

export class UpdateBase implements Action {
  public readonly type = BaseActionTypes.UpdateBase;

  constructor(public payload: { base: Update<BaseEntity> }) {}
}

export class UpdateBases implements Action {
  public readonly type = BaseActionTypes.UpdateBases;

  constructor(public payload: { bases: Update<BaseEntity>[] }) {}
}

export class DeleteBase implements Action {
  public readonly type = BaseActionTypes.DeleteBase;

  constructor(public payload: { id: string }) {}
}

export class DeleteBases implements Action {
  public readonly type = BaseActionTypes.DeleteBases;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearBases implements Action {
  public readonly type = BaseActionTypes.ClearBases;
}

export type BaseActions =
  | LoadBases
  | AddBase
  | UpsertBase
  | AddBases
  | UpsertBases
  | UpdateBase
  | UpdateBases
  | DeleteBase
  | DeleteBases
  | ClearBases;
